export default __webpack_public_path__ + "static/media/UploadVideoFile.0600024b.svg";